import type { ReactNode } from "react";

interface SectionProps {
  title: string;
  hint?: ReactNode;
  status?: ReactNode;
  children: ReactNode;
}

/** One part of a step: heading, one-line hint, a status pill on the right. */
export function Section({ title, hint, status, children }: SectionProps) {
  return (
    <section className="my-4 rounded-[var(--radius-card)] border-2 border-border bg-surface px-[22px] pb-5 pt-[22px]">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div>
          <h3 className="text-[21px] text-text">{title}</h3>
          {hint ? <p className="m-0 mt-1 text-[14px] text-text-muted">{hint}</p> : null}
        </div>
        {status}
      </div>
      {children}
    </section>
  );
}
